import ApplicationDetails from "@ee/components/HowToNominate/ApplicationDetails";
import EligibilityCriteria from "@ee/components/HowToNominate/EligibilityCriteria";
import StepsToApply from "@ee/components/HowToNominate/StepsToApply";
import TermsAndConditions from "@ee/components/HowToNominate/TermsAndConditions";
import { TabType } from "@hooks/useTabs";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * Emerging Enterprise (EE) How to Nominate page.
 *
 * @param page - The string identifier of the active tab (e.g., "nominations", "eligibility").
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const HowToNominateTabsFactory = (tab: TabType) => {
  switch (tab) {
    case "applicationsTab":
      return ApplicationDetails;

    case "eligibilityTab":
      return EligibilityCriteria;

    case "applyTab":
      return StepsToApply;

    case "termsConditionsTab":
      return TermsAndConditions;
  }
};

/**
 * Returns the corresponding title to render based on the provided label.
 *
 * This function is typically used to dynamically render different title based on the tab label
 * Emerging Enterprise (EE) How to Nominate page.
 *
 * @param label - The string identifier of the active tab label.
 * @returns The label corresponding to the tab
 */
export const getTitleForTabs = (label: string) => {
  if (label === "Terms & Conditions")
    return "Terms & Conditions (Award Application)";

  return label;
};
